import RouteRedirector from "./route-redirector";

export default RouteRedirector;